import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { URL_MAP } from '../../shared/urlMap';
import { environment as ENV } from '../../../environments/environment';
import { ProvinciaXPaisDTO } from '../../models/provincia-por-pais/provincia-por-pais.model';

@Injectable({
  providedIn: 'root',
})
export class ProvinciasXPaisService {
  private apiUrl = `${ENV.HOST}${URL_MAP.API.PROVINCIAS_X_PAIS}`;

  constructor(private http: HttpClient) {}

  getProvinciasPorPais(pais: string): Observable<ProvinciaXPaisDTO[]> {
    const body = {
      jsonParametros: JSON.stringify({ pais }),
    };

    return this.http.post<ProvinciaXPaisDTO[]>(this.apiUrl, body);
  }
}
